export function getPackagesWithHeaderIndexing(packages) {
  const slaTypesCountDict = {}
  const packagesWithHeaderIndex = packages.map((pkg) => {
    const type = pkg.selectedSlaType
    slaTypesCountDict[type] = slaTypesCountDict[type]
      ? slaTypesCountDict[type] + 1
      : 1
    pkg.pkgHeaderIndex = slaTypesCountDict[type]
    return pkg
  })

  return packagesWithHeaderIndex.map((pkg) => {
    pkg.pkgTotalCount = slaTypesCountDict[pkg.selectedSlaType]
    return pkg
  })
}

/**
 * Map seller's itens from packages with itemsMetadata
 *
 * This is a dummy solution to handle the scenario where the seller comes as a franchise
 * and isn't possible to distinguish if is a 3 party seller or not.
 * @param {Order} order
 * @param {Package} packages, that contains itens from same seller
 */
export function calculateSellerAccountByPackage(order, packages) {
  const {
    itemMetadata: { items },
  } = order

  const updatedPackages = packages.map((pkg) => {
    const firstItem = pkg.items[0]

    const itemMetadata = items.find((item) => item.id === firstItem.id)

    const { seller } = itemMetadata
    return {
      ...pkg,
      seller,
    }
  })
  return updatedPackages
}
